/**
 * Checks if the map tab exists on the page.
 */
export function hasMapTab(): boolean {
    const mapTab = document.querySelector("#map-tab");
    return mapTab !== null;
}

/**
 * Scrolls to and opens the map tab.
 */
export function scrollToMap(): void {
    const mapTab = document.querySelector<HTMLElement>("#map-tab");
    if (!mapTab) return;

    const headerNav = document.querySelector<HTMLElement>(".header-nav");
    const facilityTabs = document.querySelector<HTMLElement>(".rain-facility-tabs");

    const headerHeight = headerNav?.offsetHeight ?? 0;
    const tabsHeight = facilityTabs?.offsetHeight ?? 0;

    const scrollPosition = mapTab.offsetTop - headerHeight - tabsHeight;

    window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
    });

    // Trigger Bootstrap tab (if available)
    mapTab.click();
}
